<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input ttRememberId="w_prodsizes.searchtext" ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListProductSizes" [ttFilter]="setting.searchtext"></tt-list>
</tt-page>
